module.exports = __webpack_public_path__ + "static/tadashooter-a41d4a892c0deba34a3dd318d16db6ee.mp4";